import { Tabs } from '..';
import { useState, useMemo } from 'react';
import { useAccountStatus } from './hook';
import { ProductType } from 'constants/productType';
import { AccountType } from 'views/utils/enums';

type AccountTabsProps = {
  tabItems: {
    title: string;
    content: React.ReactNode;
    productType?: number;
  }[];
};

export const AccountTabs = ({ tabItems }: AccountTabsProps) => {
  const { accountInfo } = useAccountStatus();
  const accountType = accountInfo.data?.GetAccountInfo?.AccountType;
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const { tabLists, tabContents } = useMemo(() => {
    // アカウントタイプ(法人/個人)に応じて表示タブを切り替える
    // 個人アカウントにはリースファンドと海外不動産を非表示
    const visibleTabs = tabItems.filter(({ productType }) => {
      if (
        (productType === ProductType.LeaseFund || productType === ProductType.OverseasRealEstate) &&
        accountType === AccountType.Personal
      ) {
        return false;
      }
      return true;
    });
    return {
      tabLists: visibleTabs.map(({ title, productType }) => ({
        title,
        // アカウント情報に応じて有効/無効を切り替える可能性もある
        // disabled: productType === ProductType.OverseasRealEstate && accountType === AccountType.Personal
      })),
      tabContents: visibleTabs.map(({ content }) => content),
    };
  }, [tabItems]);

  return (
    <Tabs
      tabLists={tabLists}
      tabContents={tabContents}
      selectedIndex={selectedTabIndex}
      onSelect={setSelectedTabIndex}
    />
  );
};
